import Base from "./base"

export default class IsAdmin extends Base {
  constructor(Vue, store) {
    super("is-admin", Vue, store)
  }

  async before(to, from, next) {
    // adminか判定
    if (!this.store.getters["auth/isAdmin"]) {
      next({name: "Top", params: {slug: to.params.slug}})
      return
    }

    next()
  }
}
